let linkActiveClass = "active";

export default {

};
